module.exports = __webpack_public_path__ + "img/char-fy.be4aeab1.svg";